import { render, staticRenderFns } from "./ModalCadastroTarefaOnline.vue?vue&type=template&id=5e5e0b18"
import script from "./ModalCadastroTarefaOnline.vue?vue&type=script&lang=js"
export * from "./ModalCadastroTarefaOnline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports